/* global Set */
class ButtonDebouncer {
  constructor() {
    this.activeButtons = new Set();
  }

  init() {
    this.attachListeners();
  }

  attachListeners() {
    // Handle form submissions
    document.addEventListener('submit', (event) => {
      this.handleFormSubmit(event);
    });

    // Handle button clicks (for non-form buttons)
    document.addEventListener('click', (event) => {
      const button = event.target.closest('button[type="button"], .btn');
      if (button && !button.closest('form') && !button.classList.contains('no-debounce')) {
        this.debounceButton(button);
      }
    });
  }

  handleFormSubmit(event) {
    const form = event.target;

    // Skip debouncing for forms with Altcha widgets or no-debounce class
    if (form.querySelector('altcha-widget') || form.classList.contains('no-debounce')) {
      return;
    }

    // Find the button that actually triggered the submission
    const clickedButton = event.submitter || document.activeElement;

    // Fallback: if submitter is not available, look for the clicked button
    const submitButton = clickedButton && clickedButton.type === 'submit'
      ? clickedButton
      : form.querySelector('[type="submit"]:focus') || form.querySelector('[type="submit"]');

    if (submitButton && !submitButton.classList.contains('no-debounce')) {
      // Delay button debouncing to allow form submission to process first
      setTimeout(() => {
        this.debounceButton(submitButton, true);
      }, 10);
    }
  }

  debounceButton(button, isSubmit = false) {
    if (this.activeButtons.has(button)) {
      return;
    }

    this.activeButtons.add(button);

    // Store original state
    const originalText = button.innerHTML;
    const originalDisabled = button.disabled;
    const originalClasses = button.className;

    // Show loading state
    button.disabled = true;

    if (isSubmit) {
      // For submit buttons, show a more generic loading state
      const icon = button.querySelector('i');
      if (icon) {
        icon.className = 'fas fa-spinner fa-spin me-2';
      }
      const textContent = button.textContent.replace(/^\s*.*?\s*/, '').trim();
      button.innerHTML = `<i class="fas fa-spinner fa-spin me-2"></i>${textContent || 'Processing...'}`;
    } else {
      // For regular buttons, show button-specific loading
      button.classList.add('btn-loading');
      button.innerHTML = '<i class="fas fa-spinner fa-spin me-2"></i>Loading...';
    }

    // Reset after delay
    const resetDelay = isSubmit ? 3000 : 2000;
    setTimeout(() => {
      this.resetButton(button, originalText, originalDisabled, originalClasses);
    }, resetDelay);
  }

  resetButton(button, originalText, originalDisabled, originalClasses) {
    this.activeButtons.delete(button);
    button.innerHTML = originalText;
    button.disabled = originalDisabled;
    button.className = originalClasses;
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new ButtonDebouncer().init();
  });
} else {
  new ButtonDebouncer().init();
}